//Checkout button show/hdei logic as per SSP btns visibility
const element1Selector = '.ssp-checkout-button-container';
const element2Selector = '.cart-drawer .cart__ctas';
const cartDrawerSelector = '.cart-drawer';

function toggleElement() {
  const element1 = document.querySelector(element1Selector);
  const element2 = document.querySelector(element2Selector);

  if (!element2) return;

  element2.style.display = element1 ? 'none' : 'flex';
}

// Initial run
toggleElement();

// Wait for cart drawer to exist
const cartDrawer = document.querySelector(cartDrawerSelector);

if (cartDrawer) {
  let timeout;

  const observer = new MutationObserver(() => {
    clearTimeout(timeout);
    timeout = setTimeout(toggleElement, 50); // debounce
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}



//detach and insert Sezzle
// function moveSezzleButton() {
//   const sezzleBtn = document.querySelector(".sezzle-shopify-info-button");
//   const target = document.querySelector(".qty-buy-btn-wrap");
//   const originalParent = document.querySelector('.price-badge-wrap');

//   if (!sezzleBtn || !target) return;

//   if (window.innerWidth <= 767) {
//     // Move after target (mobile)
//     target.parentNode.insertBefore(sezzleBtn, target.nextSibling);
//   } else if (originalParent && !originalParent.contains(sezzleBtn)) {
//     // Move back to original parent (desktop)
//     originalParent.appendChild(sezzleBtn);
//   }
// }

//state selection JS on menu item link
document.querySelectorAll('.js-state-selector').forEach(function (el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();
    reopenStateSelector();
  });
});


$(document).ready(function(){

    //cart upsell slider
    $("#cartUpsellSlider").owlCarousel({
        loop: true,
        margin: 15,
        nav: false,
        navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#958E8E"/>
            <path d="M27 20H13" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L13 20L20 27" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="20" fill="#BEFF00"/>
            <path d="M13 20H27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L27 20L20 27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
        ],
        dots: true,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.1
            },
            600: {
                items: 1.1
            },
            1000: {
                items: 1.3
            }
        }
    });
    
    //reviews slider
    $("#reviewsSlider").owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#958E8E"/>
            <path d="M27 20H13" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L13 20L20 27" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="20" fill="#BEFF00"/>
            <path d="M13 20H27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L27 20L20 27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
        ],
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.2
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });

    //reviews slider 2
    $("#reviewsSlider2").owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#958E8E"/>
            <path d="M27 20H13" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L13 20L20 27" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="20" fill="#BEFF00"/>
            <path d="M13 20H27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20 13L27 20L20 27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
        ],
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.2
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });
    
    //manual state clicker on mobile menu
    $('#triggerBtn').on('click', function() {
        $('.state-change-link').trigger('click');
    });

    //reviews click and scroll to bottom reviews
    document.addEventListener("click", function (e) {
        const target = e.target.closest(".stamped-product-reviews-badge");
        if (target) {
            e.preventDefault();
            const reviewsSection = document.getElementById("stamped-main-widget");
            if (reviewsSection) {
                reviewsSection.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    });

    //detach and insert Sezzle
    //moveSezzleButton();


    let allAccordionsSection = document.querySelectorAll('.new-accordion-wrap');
    if(allAccordionsSection){
        allAccordionsSection.forEach((accordionWrap) => {
            const accordionHeaders = accordionWrap.querySelectorAll('.accordion-header');

            accordionHeaders.forEach((header) => {
                header.addEventListener('click', () => {
                    const item = header.parentElement;
                    const isActive = item.classList.contains('active');

                    // Close all items inside *this accordion only*
                    accordionWrap.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

                    // If this wasn't active before, open it
                    if (!isActive) {
                        item.classList.add('active');
                    }
                });
            });
        });
    }


    const triggerButtons = document.querySelectorAll(".triggerChatBox");
    if(triggerButtons){
        triggerButtons.forEach((btn) => {
            btn.addEventListener("click", function (e) {
            e.preventDefault();

            // Wait until the Gorgias widget API is ready
            const interval = setInterval(() => {
                if (window.GorgiasChat && window.GorgiasChat.open) {
                clearInterval(interval);
                window.GorgiasChat.open(); // ✅ this opens the chat box
                }
            }, 300);

            // optional timeout so we don't poll forever
            setTimeout(() => clearInterval(interval), 7000);
            });
        });
    }




});


window.addEventListener("resize", moveSezzleButton);



(function () {
  function initProductRecommendationsSlider() {
    var $slider = $("#productRecommendationsSlider");

    if (!$slider.length || $slider.hasClass("owl-loaded")) return;

    $slider.owlCarousel({
      loop: true,
      margin: 15,
      nav: true,
      navText: [
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" stroke="#958E8E"/>
          <path d="M27 20H13" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 13L13 20L20 27" stroke="#958E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect width="40" height="40" rx="20" fill="#BEFF00"/>
          <path d="M13 20H27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 13L27 20L20 27" stroke="#041E16" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
      ],
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1.2 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  }

  // Observe DOM changes
  var observer = new MutationObserver(function () {
    if (document.querySelector("#productRecommendationsSlider")) {
      initProductRecommendationsSlider();
      observer.disconnect(); // stop observing once initialized
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
